import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <span>© {new Date().getFullYear()} DSS Admin</span>
        <span className="footer-spacer" />
        <span>Version 1.0</span>
      </div>
    </footer>
  );
};

export default Footer;
